import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { SpecialArticle } from "@/types/article";

export const useSpecialArticle = (slug: string) => {
  return useQuery({
    queryKey: ["special-article", slug],
    queryFn: async () => {
      console.log("Fetching special article with slug:", slug);
      
      const { data, error } = await supabase
        .from("special_articles")
        .select("*")
        .eq("slug", slug)
        .maybeSingle();

      if (error) {
        console.error("Error fetching special article:", error);
        throw error;
      }

      if (!data) {
        console.log("No special article found with slug:", slug);
        throw new Error("Special article not found");
      }

      console.log("Found special article:", data);
      return data as SpecialArticle;
    },
    retry: false,
  });
};